import { get } from "lodash-es";

const actions = {
  async listActiveCampaigns(context, payload) {
    try {
      const response = await this.$api.call(
        "campaign.listActiveCampaigns",
        payload,
      );
      const responseData = response.data;

      context.commit("setActiveCampaigns", responseData);

      return response;
    } catch (error) {
      context.commit("setActiveCampaigns", []);
      throw error;
    }
  },

  async listExpiredCampaigns(context, payload) {
    try {
      const response = await this.$api.call(
        "campaign.listExpiredCampaigns",
        payload,
      );
      const responseData = response.data;

      context.commit("setExpiredCampaigns", responseData);

      return response;
    } catch (error) {
      context.commit("setExpiredCampaigns", []);
      throw error;
    }
  },
  async detailCampaign(context, payload) {
    if (!get(payload, "params.idNumber")) {
      context.commit("setCampaign", {});
      return {};
    }

    try {
      const response = await this.$api.call("campaign.detailCampaign", payload);
      const responseData = response.data;

      context.commit("setCampaign", responseData);

      return response;
    } catch (error) {
      context.commit("setCampaign", {});
      throw error;
    }
  },

  async listChannelData(context, payload) {
    try {
      const response = await this.$api.call(
        "campaign.listChannelData",
        payload,
      );
      const responseData = response.data;

      context.commit("setChannelData", responseData);

      return response;
    } catch (error) {
      context.commit("setChannelData", {
        code: "",
        partners: [],
        payment_methods: [],
      });
      throw error;
    }
  },

  async listCategories(context, payload) {
    try {
      const response = await this.$api.call("campaign.listCategories", payload);
      const responseData = response.data;

      context.commit("setCategories", responseData);

      return response;
    } catch (error) {
      context.commit("setCategories", []);
      throw error;
    }
  },

  async getPresign(_context, payload) {
    try {
      const response = await this.$api.call("campaign.getPresign", payload);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCampaign(_context, payload) {
    try {
      const response = await this.$api.call("campaign.create", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async createCampaignV2(_context, payload) {
    try {
      const response = await this.$api.call("campaign.createV2", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async updateCampaign(_context, payload) {
    try {
      const response = await this.$api.call("campaign.update", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async updateCampaignV2(_context, payload) {
    try {
      const response = await this.$api.call("campaign.updateV2", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async modifyCampaign(_context, payload) {
    try {
      const response = await this.$api.call("campaign.modify", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },

  async generatePromotionCode(context, payload) {
    try {
      const response = await this.$api.call(
        "campaign.generatePromotionCode",
        payload,
      );

      context.commit("setPromotionCodes", response.data);

      return response;
    } catch (err) {
      context.commit("setPromotionCodes", {});
      throw err;
    }
  },

  async listCampaignCombinations(context, payload) {
    try {
      const response = await this.$api.call(
        "campaign.listCampaignCombination",
        payload,
      );

      context.commit("setCampaignCombinations", response.data);

      return response;
    } catch (err) {
      context.commit("setCampaignCombinations", []);
      throw err;
    }
  },
};

export default actions;
